<template>
  <modal @close="modals.paymentDocumentRequestModal = false">
      <h3>Request A New {{ capitalizeType }}</h3>
      <div class="large-form">
          <div class="form-line">
              <div id="form-field-message" class="form-field" >
                  <label for="form-input-message">Your {{ capitalizeType }} Request</label>
                  <textarea v-model="documentRequestMessage" id="form-input-message" required="required" rows="5" />
              </div>
          </div>
          <p v-if="documentType=='invoice'">Please let us know what you want to get invoiced for.<br>We will process your request, create the invoice<br>and send it over you.</p>
          <p v-if="documentType=='receipt'">Please let us know what campaigns, time range or other parameters you want to get receipt for.<br>We will create the receipt and send it to you.</p>
          <div class="modal-errors">
              <p v-for="e in errors" class="form-field error-text">{{ e[0] }}</p>
          </div>
      </div>
      <div class="form-actions">
          <span class="ws-button ws-button-main" data-action="start-campaign-confirm" @click="sendPaymentDocumentRequest">REQUEST INVOICE</span>
          <span class="ws-button ws-button-secondary" data-action="cancel" @click="modals.paymentDocumentRequestModal = false">GO BACK</span>
      </div>
  </modal>
</template>


<script>
import Modal from "@/components/modals/Modal";

export default {
    name: "PaymentDocumentRequesModal",
    components: {Modal},
    props: {
        teamId: Number,
        documentType: String,
    },
    data() {
        return {
            documentRequestMessage: '',
            errors: {},
        }
    },
    methods: {
        async sendPaymentDocumentRequest() {
            if (!this.demoCheck()) return;
            
            this.errors = this.validateFields([
                { name: 'Message', value: this.documentRequestMessage, rules: ['required'] },
            ]);
            if (this.errors.length) return;
            await this.dispatchWaitAndNotify('paymentDocumentRequest', {type: this.documentType, message: this.documentRequestMessage});
            this.$emit('created');
        },
    },
    computed: {
        team() {
            return this.$store.state.team.detail;
        },
        modals() {
            return this.$store.state.modals;
        },
        capitalizeType() {
          return this.documentType.charAt(0).toUpperCase() + this.documentType.slice(1);
        }
    }
}
</script>

<style scoped>

</style>